import {getFormMessages, isAssignedTickets} from '@wix/wix-events-commons-statics'
import {isTemplate} from '../../../../../commons/selectors/instance'
import {isAllTicketDetailsValid} from '../../selectors/checkout'
import {getEvent} from '../../selectors/event'
import {getGiftCardPaymentDetails} from '../../selectors/invoice'
import {isEventPreview} from '../../selectors/navigation'
import {getInvoice} from '../../selectors/placed-order'
import {hasAgreedWithPolicies, hasPolicies} from '../../selectors/policies'
import {getReservationId} from '../../selectors/reservation'
import {DetailsPageAppProps} from '../app/interfaces'
import {connect} from '../runtime-context/context'
import {Checkout as CheckoutPresentation} from './checkout'
import {CheckoutOwnProps, CheckoutRuntimeProps} from './interfaces'

const mapRuntime = ({
  state,
  actions: {
    placeOrderButtonClicked,
    submitCheckoutStep,
    editStep,
    setValidPaymentAdded,
    paymentMethodSelected,
    setExpandedTicketIndex,
    handleNextStep,
    updateOrder,
  },
}: DetailsPageAppProps): CheckoutRuntimeProps => {
  const {validPaymentAdded, currentStep, buyerDetails} = state.checkout
  const event = getEvent(state)

  return {
    eventId: event.id,
    reservationId: getReservationId(state),
    placedOrder: state.placedOrder,
    invoice: getInvoice(state),
    giftCardPaymentDetails: getGiftCardPaymentDetails(state),
    validPaymentAdded,
    currentStep,
    assignedTicketsEnabled: isAssignedTickets(event),
    buyerDetails,
    agreedWithPolicies: hasAgreedWithPolicies(state),
    hasPolicies: hasPolicies(state),
    allTicketDetailsValid: isAllTicketDetailsValid(state),
    isTemplate: isTemplate(state),
    eventPreview: isEventPreview(state),
    messages: getFormMessages(event),
    placeOrderButtonClicked,
    submitCheckoutStep,
    editStep,
    setValidPaymentAdded,
    paymentMethodSelected,
    setExpandedTicketIndex,
    handleNextStep,
    updateOrder,
  }
}

export const Checkout = connect<CheckoutOwnProps, CheckoutRuntimeProps>(mapRuntime)(CheckoutPresentation)
